/**
 * Horizontal frame of the price pane (visible range + price-scale widths),
 * published by PriceChart's onAxisChange and consumed by the ECharts panes so
 * every pane maps time → pixel identically.
 */
import { create } from "zustand";
import type { AxisFrame } from "@/components/PriceChart";

interface AxisState {
  frames: Record<string, AxisFrame>;
  set: (id: string, f: AxisFrame) => void;
}

export const useAxisFrames = create<AxisState>((set) => ({
  frames: {},
  set: (id, f) =>
    set((s) => {
      const prev = s.frames[id];
      if (
        prev &&
        prev.from === f.from &&
        prev.to === f.to &&
        prev.left === f.left &&
        prev.right === f.right &&
        prev.width === f.width
      )
        return s;
      return { frames: { ...s.frames, [id]: f } };
    }),
}));

export function useAxisFrame(id: string): AxisFrame | undefined {
  return useAxisFrames((s) => s.frames[id]);
}
